import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import SubnetService from "../../../../../service/SubnetService";
import { useToastContext } from "../../../../../contexts/ToastContext/ToastContext";
import ReferralQrDialog from "../ReferralQrDialog/ReferralQrDialog";
import { buildConfimeaAssociationUrl } from "../../../../../constants/confimeaAssociation";
import localeText from "../../../../../locale";

const subnetService = new SubnetService();

const AssociationConfimeaShare = ({ username }) => {
  const { showInfoToast } = useToastContext();
  const [memberInfo, setMemberInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [qrVisible, setQrVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function fetchMemberInfo() {
      const token = localStorage.getItem("__extraconomy_token");
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const res = await subnetService.getSubnetMember(token);
        if (!cancelled && (res.messageCode === 200000 || res.messageCode === 200001)) {
          setMemberInfo(res.result ?? null);
        }
      } catch (e) {
        console.log(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchMemberInfo();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading || !memberInfo?.association || !memberInfo?.documentAssociation || !username) {
    return null;
  }

  const shareUrl = buildConfimeaAssociationUrl(username);

  const handleCopy = () => {
    if (JSON.parse(localStorage.getItem("__extraconomy_ismobile__") || "false")) {
      window.ReactNativeWebView?.postMessage?.(
        JSON.stringify({ content: shareUrl, clipboard: true }),
      );
    } else {
      navigator.clipboard?.writeText(shareUrl);
    }
    showInfoToast({ summary: "copied", detail: "copiedToClipboard" });
  };

  return (
    <>
      <div
        className="card border-round-xl p-4"
        style={{ border: "1px solid var(--theme-border, #EBEBEB)" }}
      >
        <div className="flex flex-column gap-2">
          <div className="text-md font-semibold" style={{ color: "var(--theme-text)" }}>
            {localeText("associationConfimeaShareTitle")}
          </div>
          <p className="text-sm m-0" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
            {localeText("associationConfimeaShareDescription")}
          </p>
          <div
            className="text-xs p-3 border-round-lg word-break-all"
            style={{
              backgroundColor: "color-mix(in srgb, var(--theme-border) 40%, transparent)",
              color: "var(--theme-text-muted)",
            }}
          >
            {shareUrl}
          </div>
          <div className="flex flex-wrap gap-2 mt-1">
            <Button
              label={localeText("copy")}
              icon="pi pi-copy"
              className="p-button-outlined p-button-sm border-round-md p-no-outline"
              onClick={handleCopy}
              style={{
                color: "var(--theme-text-muted)",
                border: "1px solid var(--theme-border)",
              }}
            />
            <Button
              icon="pi pi-qrcode"
              className="p-button-outlined p-button-sm border-round-md p-no-outline"
              onClick={() => setQrVisible(true)}
              style={{
                color: "var(--theme-text-muted)",
                border: "1px solid var(--theme-border)",
              }}
            />
          </div>
        </div>
      </div>

      <ReferralQrDialog
        visible={qrVisible}
        onHide={() => setQrVisible(false)}
        url={shareUrl}
        titleKey="associationConfimeaShareTitle"
      />
    </>
  );
};

export default AssociationConfimeaShare;
